import component from './index.vue'

const Plugin = {
  install (Vue, options = {}) {
    if (this.installed) {
      return
    }
    this.installed = true
    this.event = new Vue()

    Vue.component('searchCount', component)
    // Vue.mixin({
    // })

    Vue.prototype.$searchCount = {
    }
  }
}

// This exports the plugin object.
export default Plugin
